import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useAppStore } from "@/pinia/app";


export default /*#__PURE__*/_defineComponent({
  __name: 'DjangoRouterLink',
  props: {
  /**
   * The path to the page, relative to the Django site origin.
   * Named similarly to the Vue Router `to` prop on router-link.
   */
  to: {
    type: String,
    required: true,
    validator(v: string): boolean {
      return v.startsWith("/");
    },
  },
  noDecoration: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

/**
 * This component is used to create links to pages that are not part of
 * Almanac+ and specifically are a part of the rest of our Django site.
 */


/**
 * The computed value of the `to` prop, or an empty string if it is not provided.
 */
const to = computed(() => {
  return props.to ?? "";
});

const appStore = useAppStore();
const djangoSiteOrigin = computed(() => appStore.djangoSiteOrigin);

const href = computed(() => {
  return `${djangoSiteOrigin.value}${to.value}`;
});

const style = computed(() => {
  if (props.noDecoration) {
    return `text-decoration: none; color: unset;`;
  }
  return "";
});

return { __sfc: true,props, to, appStore, djangoSiteOrigin, href, style }
}

})